// extracted by mini-css-extract-plugin
module.exports = {"content-padding":"ReallocateBudgetModal_content-padding__a6gqB"};